import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { connect } from "react-redux";

// Externals
import PropTypes from "prop-types";
import _ from "lodash";
// Material helpers
import { withStyles } from "@material-ui/core";
// Component styles
import styles from "./styles";
import { connectorPlaceholderImage } from "../../../../common/utils";
import { bindActionCreators } from "redux";
import { fetchConnections } from "../../../../redux/actions/connectionActions";
import { pushMessage } from "../../../../redux/actions/commonActions";
import DialogButtons from "./dialogButtons";
import AvailableConnectorRegular from "./availableRegular";
import AvailableFAQConnector from "./availableFAQ";
import AvailableCustomWithURL from "./availableCustomWithURL";

class ConnectionDialog extends React.Component {
  fallbackIntentExists = () => {
    return this.props.fallbackIntentData !== undefined && this.props.fallbackIntentData !== null;
  };

  getFallbackIntentDataForFaqConnector = (connection, faqConnectionName) => {
    if (connection.connectionName !== faqConnectionName) {
      return {};
    }

    if (!this.fallbackIntentExists()) {
      return {};
    }

    return {
      fallbackIntentPlainTextResponse: this.props.fallbackIntentData.body,
      fallbackIntentRichCardResponse: this.props.fallbackIntentData.alexalyticsCardBody,
      fallbackIntentId: this.props.fallbackIntentData.ID
    };
  };

  state = {
    "servicenow-prod": {
      values: { url: "" },
      errors: { url: "" },
      label: ".service-now.com"
    },
    "zendesk-prod": {
      values: { url: "" },
      errors: { url: "" },
      label: ".zendesk.com"
    },
    Dynamics_365: {
      values: { url: "" },
      errors: { url: "" },
      label: ".crm.dynamics.com"
    },
    "faq-dev": {
      values: { faq_name: "", image: null },
      errors: { faq_name: "", image: "" }
    },
    faq: {
      values: {
        faq_name: "",
        image: null,
        ...this.getFallbackIntentDataForFaqConnector(this.props.connection, "faq")
      },
      errors: { faq_name: "", image: "" }
    },
    customConnectors: ["servicenow-prod", "zendesk-prod", "Dynamics_365"]
  };

  componentDidMount() {
    if (
      _.get(this.props, "connection.base_url", false) &&
      _.includes(this.props.customConnectors, this.props.connection.connectionName) &&
      _.get(this.props, "connection.tenant", false)
    ) {
      this.handleFieldChange(
        "url",
        _.get(this.props, "connection.enabled", true)
          ? _.get(this.props, "connection.base_url", "")
              .replace("https://", "")
              .replace(this.state[this.props.connection.connectionName].label, "")
          : ""
      );
    }

    if (_.get(this.props, "editableContent[0]", false)) {
      this.handleFieldChange("faq_name", _.get(this.props, "editableContent[0].display_name", ""));
      this.handleFieldChange("image", _.get(this.props, "editableContent[0].image", ""));
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      _.get(nextProps, "connection.base_url", false) &&
      _.includes(nextProps.customConnectors, nextProps.connection.connectionName) &&
      _.get(nextProps, "connection.tenant", false)
    ) {
      this.handleFieldChange(
        "url",
        _.get(nextProps, "connection.enabled", true)
          ? _.get(nextProps, "connection.base_url", "")
              .replace("https://", "")
              .replace(this.state[nextProps.connection.connectionName].label, "")
          : ""
      );
    }
  }

  onConnectClick = async () => {
    let { connection } = this.props;
    let url = "";
    if (this.state[connection.connectionName]) {
      const newState = { ...this.state };
      if (_.includes(this.state.customConnectors, connection.connectionName)) {
        url = `https://${this.state[connection.connectionName].values.url}${this.state[connection.connectionName].label}`;
        newState[connection.connectionName].errors.url = this.state[connection.connectionName].values.url
          ? ""
          : "Base URL is required!";
      }
      this.setState(newState);
      if (newState[connection.connectionName].errors.url) return;
    }
    await this.props.handleConnect(undefined, undefined, url);
    this.props.handleClose();
  };

  onPublicAPIConnectClick = async () => {
    let { connection } = this.props;
    if (this.state[connection.connectionName]) {
      const newState = { ...this.state };
      newState[connection.connectionName].errors.faq_name = this.state[connection.connectionName].values.faq_name
        ? ""
        : "Name is required!";
      this.setState(newState);
      if (newState[connection.connectionName].errors.faq_name) return;
    }

    let data;

    // `data` will be undefined when the connector doesn't exist in this.state which also means it will not have a form
    // in which the user can input values.
    try {
      data = this.state[this.props.connection.connectionName]["values"];
    } catch (e) {
      data = undefined;
    }

    await this.props.handlePublicRestConnect(data, "insert");
    this.props.handleClose();
  };

  onPublicAPIConnectClickEdit = async () => {
    let { connection } = this.props;
    if (this.state[connection.connectionName]) {
      const newState = { ...this.state };
      newState[connection.connectionName].errors.faq_name = this.state[connection.connectionName].values.faq_name
        ? ""
        : "Name is required!";
      this.setState(newState);
      if (newState[connection.connectionName].errors.faq_name) return;
    }
    await this.props.handlePublicRestConnect(this.state[this.props.connection.connectionName]["values"], "edit");
    this.props.handleClose();
    this.props.fetchConnections();
  };

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };
    newState[this.props.connection.connectionName].values[field] = value;
    this.setState(newState, this.validateForm);
  };

  getConnectorImage = () => {
    let connectorImage;
    if (_.get(this.state[this.props.connection.connectionName], "values.image", false)) {
      connectorImage = this.state[this.props.connection.connectionName].values.image;
    } else {
      connectorImage = this.props.connection.image;
    }

    if (connectorImage) {
      return connectorImage;
    }

    return connectorPlaceholderImage;
  };

  updateConnectorImage = imageUrl => {
    this.handleFieldChange("image", imageUrl);
  };

  /**
   * Render different dialog title based on current connection name.
   */
  renderDialogTitle = connection => {
    // FAQ connector
    if (["faq-dev", "faq"].indexOf(connection.connectionName) >= 0) {
      return <DialogTitle id="form-dialog-title">Setup {connection.connectorName}</DialogTitle>;
    }

    // Regular connector
    return <DialogTitle id="form-dialog-title">Setup {connection.connectorName} Connection</DialogTitle>;
  };

  /**
   * Depending on connector type, render the correct dialog content.
   * There are three connector types: FAQ connector, fallback intent setup and regular connectors.
   */
  renderDialogContent = (connection, classes) => {
    if (["faq-dev", "faq"].indexOf(connection.connectionName) >= 0) {
      let shouldRenderFallbackIntentFields = false;

      if (connection.connectionName === "faq") {
        // The fields for updating the fallback intent might be only shown for the FAQ connector
        shouldRenderFallbackIntentFields = this.fallbackIntentExists();
      }

      return (
        <AvailableFAQConnector
          getConnectorImage={this.getConnectorImage}
          updateConnectorImage={this.updateConnectorImage}
          classes={classes}
          handleFieldChange={this.handleFieldChange}
          state={this.state}
          connection={connection}
          administrator={this.props.administrator}
          shouldRenderFallbackIntentFields={shouldRenderFallbackIntentFields}
        />
      );
    }

    return (
      <AvailableConnectorRegular getConnectorImage={this.getConnectorImage} connection={connection} classes={classes} />
    );
  };

  render() {
    const { connection, classes, editableContent, administrator } = this.props;

    const enabled = administrator === true ? connection.enabled : true;
    // console.log(
    //   connection.connectionName,
    //   !this.state.enabled,
    //   !connection.enabled,
    //   _.includes(this.props.customConnectors, connection.connectionName)
    // );
    return (
      <React.Fragment>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="form-dialog-title"
          disableBackdropClick={true}
          maxWidth="xs"
        >
          {this.renderDialogTitle(connection)}

          <DialogContent dividers>
            <div className={classes.dataContainer}>{this.renderDialogContent(connection, classes)}</div>
            {!enabled && !connection.enabled && _.includes(this.props.customConnectors, connection.connectionName) && (
              <AvailableCustomWithURL
                classes={classes}
                connection={connection}
                state={this.state}
                handleFieldChange={this.handleFieldChange}
              />
            )}
          </DialogContent>

          <DialogActions>
            <DialogButtons
              connection={connection}
              enabled={enabled}
              editableContent={editableContent}
              handleClose={this.props.handleClose}
              onPublicAPIConnectClick={this.onPublicAPIConnectClick}
              onConnectClick={this.onConnectClick}
              onPublicAPIConnectClickEdit={this.onPublicAPIConnectClickEdit}
              buildTriggered={this.props.botBuildTriggered}
              administrator={this.props.administrator}
            />
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

ConnectionDialog.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  connection: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator",
    botBuildTriggered: state.intents["botBuildTriggered"] ? state.intents.botBuildTriggered : false,
    fallbackIntentData: state.connections.fallbackIntent
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchConnections,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

ConnectionDialog = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectionDialog);

export default withStyles(styles)(ConnectionDialog);
